import * as constants from 'helper/constants';
import queryString from 'qs';
import React from 'react';
import ReactDOM from 'react-dom';

import API from 'api/api';
import MockAPI from 'helper/mockApi';
import App from './App';
import registerServiceWorker from './registerServiceWorker';

const query = queryString.parse(window.location.search.substring(1));

// Use mock API in tests
let api;
if (process.env.NODE_ENV === 'test') {
  api = new MockAPI();
} else {
  api = new API(
    constants.apiUrl,
    constants.apiClientId,
    constants.apiClientSecret
  );
}


ReactDOM.render(
  <App
    api={Object.seal(api)}
    query={query}
  />,
  document.getElementById('root'),
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.jsx